module.exports = __webpack_public_path__ + "img/olja1.7c52e608.jpg";